import apps from './apps';

export const UNITY_BUILDS = require('./app-manifests/production.json');

export const {
  NODE_ENV,
  BUILD_ENVIRONMENT,
  API_URL,
  PAYMENTS_API_URL,
  SITE_HOST,
  COOKIE_DOMAIN,
  AMPLITUDE_ENV,
  STRIPE_PUBLIC_KEY,
  RELEASE_VERSION,
} = process.env;

export const IS_PROD = NODE_ENV === 'production';
export const CANONICAL_URL = 'https://schools.tinybop.com';
export const UNITY_ASSETS_URL = 'https://schools-cdn.tinybop.com/game-builds/';
export const LOCALIZED_MESSAGES_URL = '/assets/localized-messages/';

console.log('API_URL', API_URL);
console.log('PAYMENTS_API_URL', PAYMENTS_API_URL);
console.log('RELEASE_VERSION', RELEASE_VERSION);
console.log(process.env);

export const PLAYER_URL = window
  ? `${window.location.protocol}//${window.location.host}`
  : '';

export const FEATURE_FLAGS = {
  studentActivity: false,
};

export const appData = [
  { ...apps['states-of-matter'] },
  { ...apps['human-body'] },
  { ...apps['coral-reef'] },
  { ...apps.weather },
  { ...apps.space },
  { ...apps['simple-machines'] },
  { ...apps.mammals },
  { ...apps.earth },
  { ...apps.skyscrapers },
  { ...apps.homes },
];

export const appDataByKey = apps;

// export const ISRAEL_STUDENT_DEMO_TOKEN = environment.ISRAEL_STUDENT_DEMO_TOKEN;
